import React, { useCallback, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LanguageContext";
import { PublicHeader } from "./PublicHeader";
import { MobileDrawer } from "./MobileDrawer";
import { PublicFooter } from "./PublicFooter";

export function PublicLayout({ children }) {
  const { user, logout } = useAuth();
  const { t } = useLang();
  const loc = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const isHome = loc.pathname === "/";
  const useLightHeader = isHome && !scrolled && !mobileOpen;

  const handlePublicLogout = useCallback(async () => {
    await logout();
    window.location.assign("/");
  }, [logout]);

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 12);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);
  useEffect(() => { setMobileOpen(false); }, [loc.pathname]);

  return (
    <div className="min-h-screen flex flex-col brand-body" style={{ background: "var(--bk-ivory)" }}>
      <PublicHeader
        user={user}
        locPath={loc.pathname}
        useLightHeader={useLightHeader}
        mobileOpen={mobileOpen}
        onToggleMobile={() => setMobileOpen((o) => !o)}
        onLogout={handlePublicLogout}
        t={t}
      />
      {mobileOpen && (
        <MobileDrawer user={user} locPath={loc.pathname} onLogout={handlePublicLogout} t={t} />
      )}
      <main className="flex-1">{children}</main>
      <PublicFooter />
    </div>
  );
}
